import { render, staticRenderFns } from "./VContributionStatus.vue?vue&type=template&id=5d94ec77&"
import script from "./VContributionStatus.vue?vue&type=script&lang=ts&"
export * from "./VContributionStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports